"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isEmail = exports.typify = void 0;
var typify = function (obj) { return obj; };
exports.typify = typify;
var emailRegex = new RegExp("^(([^<>()\\[\\]\\\\.,;:\\s@\"]+(\\.[^<>()\\[\\]\\\\.,;:\\s@\"]+)*)|(\".+\"))@((\\[[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}])|(([a-zA-Z\\-0-9]+\\.)+[a-zA-Z]{2,}))$");
var isEmail = function (email) { return !!email.match(emailRegex); };
exports.isEmail = isEmail;
